import React from "react" ;

import "../../styles/UI/childButton.scss";

const ChildButton = ({ value, onClick }) => {
    return (
        <div className="custom-field">
            <button 
                className="child-button"
                onClick={onClick}
            >
                {value}
            </button>
        </div>
    );
}

export default ChildButton;
